/*
 * Copyright (c) Akveo 2019. All Rights Reserved.
 * Licensed under the Single Application / Multi Application License.
 * See LICENSE_SINGLE_APP / LICENSE_MULTI_APP in the 'docs' folder for license information on type of purchased license.
 */

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { PatientDemographicsMasterApi } from '../api/patientDemographicsMaster.api';
import { switchMap, map } from 'rxjs/operators';
import { PatientDemographicsMasterData,PatientDemographicsMaster} from '../../../interfaces/masters/patientDemographicsMaster';

@Injectable()
export class PatientDemographicsMasterService extends PatientDemographicsMasterData {

  constructor(private api: PatientDemographicsMasterApi) {
    super();
  }


  list(url: string): Observable<PatientDemographicsMaster[]> {
    return this.api.list(url);
  }


  create(url: string, data: PatientDemographicsMaster): Observable<PatientDemographicsMaster> {
    return this.api.add(url, data);
  }


  update(url: string, data: PatientDemographicsMaster): Observable<PatientDemographicsMaster> {
    return this.api.update(url, data);
  }


}
